import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@views/home/home-own.vue';
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/tech/legalllm',
        name: 'legalllm',
        component: () => import('@views/_landings/tech_legalllm/legalllm.vue'),
    },
    {
        path: '/products/internalctrl',
        name: 'internalctrl',
        component: () => import('@views/_landings/product_innercontrol/internalctrl.vue'),
    },
    {
        path: '/products/caseretrieval',
        name: 'casetrieval',
        component: () => import('@views/_landings/product_caseretrieval/caseretrieval.vue'),
    },
    {
        path: '/products/smartreview',
        name: 'smartreview',
        component: () => import('@views/_landings/product_smartreview/smartreview.vue'),
    },
    {
        path: '/products/smartwriting',
        name: 'smartwriting',
        component: () => import('@views/_landings/product_smartwriting/smartwriting.vue'),
    },
    {
        path: '/products/vcoach',
        name: 'vcoach',
        component: () => import('@views/_landings/vcoach/vcoach.vue'),
    },
    {
        path: '/products/vroom',
        name: 'vroom',
        component: () => import('@views/_landings/vroom/vroom.vue'),
    },
    {
        path: '/products/msense',
        name: 'msense',
        component: () => import('@views/_landings/msense/msense.vue'),
    },
    {
        path: '/products/yilvkezhi',
        name: 'yilvkezhi',
        component: () => import('@views/_landings/product_yilvkezhi/yilvkezhi.vue'),
    },
    {
        path: '/products/wenshuzhishen',
        name: 'wenshuzhishen',
        component: () => import('@views/_landings/product_wenshuzhishen/wenshuzhishen.vue'),
    },
    {
        path: '/products/yilvkeliang',
        name: 'yilvkeliang',
        component: () => import('@views/_landings/product_yilvkeliang/yilvkeliang.vue'),
    },
    {
        path: '/landings/multipurpose',
        name: 'Multipurpose',
        component: () => import('@views/_landings/multipurpose/multipurpose.vue'),
    },
    {
        path: '/landings/agency',
        name: 'Agency',
        component: () => import('@views/_landings/agency/agency.vue'),
    },
    {
        path: '/landings/press',
        name: 'Press',
        component: () => import('@views/_landings/press/press.vue'),
    },
    {
        path: '/landings/directory',
        name: 'Directory',
        component: () => import('@views/_landings/directory/directory.vue'),
    },
    {
        path: '/landings/rental',
        name: 'Rental',
        component: () => import('@views/_landings/rental/rental.vue'),
    },
    {
        path: '/landings/real-estate',
        name: 'Real Estate',
        component: () => import('@views/_landings/real-estate/real-estate.vue'),
    },
    {
        path: '/landings/classifieds',
        name: 'Classifieds',
        component: () => import('@views/_landings/classifieds/classifieds.vue'),
    },
    {
        path: '/landings/lead-capture',
        name: 'Lead Capture',
        component: () => import('@views/_landings/lead-capture/lead-capture.vue'),
    },
    {
        path: '/landings/resume',
        name: 'Resume',
        component: () => import('@views/_landings/resume/resume.vue'),
    },
    {
        path: '/landings/portfolio',
        name: 'Portfolio',
        component: () => import('@views/_landings/portfolio/portfolio.vue'),
    },
    {
        path: '/headers/basic',
        name: 'Basic Header',
        component: () => import('@views/_headers/basic/basic.vue'),
    },
    {
        path: '/headers/basic-signup',
        name: 'Basic Signup',
        component: () => import('@views/_headers/basic-signup/basic-signup.vue'),
    },
    {
        path: '/headers/graphic',
        name: 'Graphic',
        component: () => import('@views/_headers/graphic/graphic.vue'),
    },
    {
        path: '/headers/graphic-signup',
        name: 'Graphic Signup',
        component: () => import('@views/_headers/graphic-signup/graphic-signup.vue'),
    },
    {
        path: '/headers/inner-page',
        name: 'Inner Page',
        component: () => import('@views/_headers/inner-page/inner-page.vue'),
    },
    {
        path: '/headers/nav-only',
        name: 'Nav Only',
        component: () => import('@views/_headers/nav-only/nav-only.vue'),
    },
    {
        path: '/pages/basic',
        name: 'Basic Page',
        component: () => import('@views/_pages/basic/basic.vue'),
    },
    {
        path: '/about/ourstory',
        name: 'MegaTech Story',
        component: () => import('@views/_pages/company-about/company-about.vue'),
    },
    {
        path: '/pages/company-pricing',
        name: 'Company Pricing',
        component: () => import('@views/_pages/company-pricing/company-pricing.vue'),
    },
    {
        path: '/about/contactus',
        name: 'Company Contact',
        component: () => import('@views/_pages/company-contact/company-contact.vue'),
    },
    {
        path: '/pages/register-login',
        name: 'Register Login',
        component: () => import('@views/_pages/register-login/register-login.vue'),
    },
    {
        path: '/pages/company-terms',
        name: 'Company Terms',
        component: () => import('@views/_pages/company-terms/company-terms.vue'),
    },
    {
        path: '/pages/help-center',
        name: 'Help Center',
        component: () => import('@views/_pages/help-center/help-center.vue'),
    },
    {
        path: '/pages/help-knowledgebase',
        name: 'Help Knowledgebase',
        component: () => import('@views/_pages/help-knowledgebase/help-knowledgebase.vue'),
    },
    {
        path: '/pages/help-message-center',
        name: 'Help Message Center',
        component: () => import('@views/_pages/help-message-center/help-message-center.vue'),
    },
    {
        path: '/pages/help-support-ticket',
        name: 'Help Support Ticket',
        component: () => import('@views/_pages/help-support-ticket/help-support-ticket.vue'),
    },
    {
        path: '/pages/careers-overview',
        name: 'Careers Overview',
        component: () => import('@views/_pages/careers-overview/careers-overview.vue'),
    },
    {
        path: '/about/joinus',
        name: 'Careers Listing',
        component: () => import('@views/_pages/careers-listing/careers-listing.vue'),
    },
    {
        path: '/pages/blog-overview',
        name: 'Blog Overview',
        component: () => import('@views/_pages/blog-overview/blog-overview.vue'),
    },
    {
        path: '/pages/blog-post',
        name: 'Blog Post',
        component: () => import('@views/_pages/blog-post/blog-post.vue'),
    },
    {
        path: '/pages/articles',
        name: 'Articles',
        component: () => import('@views/_pages/blog-archive/blog-archive.vue'),
    },
    {
        path: '/pages/portfolio-grid',
        name: 'Portfolio Grid',
        component: () => import('@views/_pages/portfolio-grid/portfolio-grid.vue'),
    },
    {
        path: '/pages/portfolio-large-grid',
        name: 'Portfolio Large Grid',
        component: () => import('@views/_pages/portfolio-large-grid/portfolio-large-grid.vue'),
    },
    {
        path: '/pages/portfolio-masonry',
        name: 'Portfolio Masonry',
        component: () => import('@views/_pages/portfolio-masonry/portfolio-masonry.vue'),
    },
    {
        path: '/pages/portfolio-case-study',
        name: 'Portfolio Case Study',
        component: () => import('@views/_pages/portfolio-case-study/portfolio-case-study.vue'),
    },
    {
        path: '/pages/portfolio-project',
        name: 'Portfolio Project',
        component: () => import('@views/_pages/portfolio-project/portfolio-project.vue'),
    },
];
const router = new VueRouter({
    mode: 'hash',
    routes,
});
export default router;
// router-link.d-block.rounded-lg.lift.lift-lg(to='/landings/basic')
